import { Link } from "@bond-london/gatsby-plugin-cms-i18next";
import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { DashedText } from "./DashedText";

export const SimpleLink: React.FC<
  PropsWithChildren<{
    to?: string | null;
    ariaLabel?: string | null;
    className?: string | null;
    isButton?: boolean | null;
  }>
> = ({ to, children, className = "", ariaLabel, isButton }) => {
  if (!to) return null;
  if (to.startsWith("/")) {
    return (
      <Link
        to={to}
        className={classNames(
          isButton ? "servicesButton" : "read-more",
          className,
          "inline-block",
        )}
        aria-label={ariaLabel ? ariaLabel : `Go to page ${to}`}
      >
        {isButton ? (
          <DashedText colorClassName={"text-hyacinth"}>{children}</DashedText>
        ) : (
          <>{children}</>
        )}
      </Link>
    );
  }

  return (
    <a
      href={to}
      className={classNames(
        isButton ? "servicesButton" : "read-more",
        className,
        "inline-block",
      )}
      aria-label={ariaLabel ? ariaLabel : `Go to page ${to}`}
    >
      {isButton ? (
        <DashedText colorClassName={"text-hyacinth"}>{children}</DashedText>
      ) : (
        <>{children}</>
      )}
    </a>
  );
};
